function Service(localStorage, $location) {
    const STORAGE_KEY = "Cars.history";

    return {
        saveRecentViewed,
        loadRecentViewed: () => loadRecentActivity().recentViewed
    };

    function loadRecentActivity(){
        const historyString = localStorage.getItem(STORAGE_KEY);
        const newRecentActivity = {
            recentSearches: [],
            recentViewed : []
        };
        const recentActivity = historyString ? JSON.parse(historyString) : newRecentActivity;
        return recentActivity.recentSearches && recentActivity.recentViewed ? recentActivity : newRecentActivity;
    }

    function saveRecentViewed(listingData) {
        if (!listingData){
            return;
        }
        const recentActivity = loadRecentActivity();
        const {listingId, stockType, makeName, modelName, modelYear, photoUrlsSmall, priceFormatted, milesInteger} = listingData;
        const vehicleData = {
            listingId,
            stockType,
            makeName,
            modelName,
            modelYear,
            photoUrl: (photoUrlsSmall && photoUrlsSmall.length > 0) ? photoUrlsSmall[0] : "https://www-np.cstatic-images.com/supersized/e/8/9/5c/2763b9e86217ea29f81d32fb447.jpg",
            priceFormatted,
            milesInteger,
            url: $location.url()
        };

        for (let i = 0, len = recentActivity.recentViewed.length; i <  len; i++) {
            if ( recentActivity.recentViewed[i].listingId === vehicleData.listingId) {
                recentActivity.recentViewed.splice(i, 1);
                break;
            }
        }

        recentActivity.recentViewed.unshift(vehicleData);
        if (recentActivity.recentViewed.length > 3){
            recentActivity.recentViewed.splice(recentActivity.recentViewed.length - 1);
        }

        localStorage.setItem(STORAGE_KEY, JSON.stringify(recentActivity));

        return recentActivity;
    }
}

Service.$inject = ['localStorageService', '$location'];

export default Service;